import { render, staticRenderFns } from "./bsp-dicts-radio.vue?vue&type=template&id=0c9ec939&scoped=true&"
import script from "./bsp-dicts-radio.vue?vue&type=script&lang=js&"
export * from "./bsp-dicts-radio.vue?vue&type=script&lang=js&"
import style0 from "./bsp-dicts-radio.vue?vue&type=style&index=0&id=0c9ec939&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9ec939",
  null
  
)

export default component.exports